module.exports = __webpack_public_path__ + "static/media/1.1a332e19.jpg";